/*******************************************************************************************************************
 *************************************************API网络请求核心文件***************************************************
 *******************************************************************************************************************/
 import axios from 'axios';
 import qs from 'qs';
 import { Message , MessageBox } from "element-ui";
 import router from '../router';
  let messageInstance = null;
  const resetMessage = (options)=>{
  //关闭上一个弹窗，继续下一个弹窗
    if(messageInstance){
      messageInstance.close()
    }
    messageInstance = Message(options)
  }
 //TODO:: 正式服接口地址
 const FORMAL_SERVER = window.location.hostname;
 //TODO:: 当前协议
 const FORMAL_PROTOCOL = window.location.protocol + "//";
 //TODO:: 【是否需要调试模式】（ 本地开发为: true ,发包的时候为: false ）
 window.__DEBUG__ = function() {
   return FORMAL_SERVER == "localhost" || FORMAL_SERVER == "127.0.0.1" || FORMAL_SERVER.indexOf("192.168.1") > -1;
 }();
 
 //TODO:: 本地开发的时候设置为本地 Tomcat 的请求地址
//  const DEVELOPER_SERVER = 'http://localhost:8080';
const DEVELOPER_SERVER = 'http://192.168.47.168:39939';
// const DEVELOPER_SERVER = 'http://192.168.1.125:8080';
// const DEVELOPER_SERVER = 'http://192.168.47.241:30039';


 //TODO:: 获取项目URL
 window.BASEURL = __DEBUG__ ? DEVELOPER_SERVER + '/api': function() {
   // 添加/api
   return FORMAL_PROTOCOL + FORMAL_SERVER + '/api';
 }();
 window.ONLINEURL = FORMAL_PROTOCOL + FORMAL_SERVER;
 /**
  * 统一异步请求处理器
  * @param {String} _url 请求的地址
  * @param {Object || Array} _params 请求的参数
  * @param {String} _method 请求的方法['GET','POST','PUT','DELETE','PATCH']
  * @param {String} _type 请求的类型['QueryString','FormData','Request Payload']
  */
 let asyncRequestHandler = (_url, _params = {}, _method = "GET", _type = "QueryString",_responseType) => {
 
   let options = {
     url: _url,
     timeout: 150000,
     method: _method,
     params: _params,
     headers: {
       //后台给的用户凭证，也可通过用户的各种信息加密签名带给后台，如：ID+用户名+随机字符 通过MD5加密生成
      //  'Q-Token': 'qindeng',
      
       'access_token':localStorage.getItem('ACCESS-TOKEN')||'',
       'X-Requested-With': 'XMLHttpRequest',
     },
     'Content-Type': "application/x-www-form-urlencoded;charset=utf-8",
     withCredentials: false, //允许带上凭据
     responseType:_responseType,
   };
   if (options.headers['access_token'] == ''){
    delete options.headers['access_token']
   }
   if (_method.toUpperCase() != 'GET') {
     options.params = null;
     //只有GET请求才能用QueryString
     if (_type.toUpperCase() == "QUERYSTRING") {
       _type = "FormData";
     }
     if (_type.toUpperCase() == "FORMDATA") { //表单发送数据
       // `transformRequest` 允许在向服务器发送前，修改请求数据，
       options.transformRequest = [function(data) {
         return qs.stringify(_params);
       }];
     } else {
       options['Content-Type'] = 'application/json;charset=utf-8';
       // options.headers['Access-Control-Allow-Headers'] = 'Access-Control-Allow-Headers';
       //if (_method.toUpperCase() != "DELETE") {
       options.data = _params;
       //}
     }
   }
   return new Promise((resolve, reject) => {
     axios(options).then(res => {
        if(res.data.code == 200 || options.responseType == 'blob'){
          if(res.data.code == 200) {
            resolve(res.data)
          }else{
            resolve(res)
          }
        }else if(res.data.code == 40200||res.data.code == 40100 ||res.data.code == 406 ||res.data.code == 403){
          // 长时间未操作
          // MessageBox.confirm(res.data.msg, '提示', {
          //   confirmButtonText: '确定',
          //   type: 'warning'
          // }).then(() => {
          //   localStorage.removeItem('ACCESS-TOKEN')
          //   router.push('/login')
          // })
            localStorage.removeItem('ACCESS-TOKEN')
            router.push('/login')
        }else{
          resetMessage({
            message: res.data.msg,
            type: "error"
          });
          reject(res.data)          
        }
     }).catch(err => {
       if (err.response) {
         let status = err.response.status;
         if (status == 403) { //未登录
            localStorage.removeItem('ACCESS-TOKEN')
            location.href = taobao.loginUri();
            return;
         }
       }
        resetMessage({
          message: err.response && err.response.data
          ? err.response.data
            : "接口出错",
          type: "error"
        });
        // reject(
        //   err.response && err.response.data
        //     ? err.response.data
        //       : {
        //         mag:"接口出错"
        //       }
        // );
     })
   });
 }
 
 /**
  * 统一文件上传异步请求处理器
  * @param {String} _url 请求的地址
  * @param {Object || Array} _params 请求的参数
  * @param {String} _call 上传进度回调
  */
 let asyncUploadHandler = (_url, _params = {}, _call) => {
   var param = new FormData();
   if (_params instanceof Array) {
     var files = [];
     for (var i = 0; i < _params.length; i++) {
       files.push(_params[i].file);
     }
     for (var $key in _params[0]) {
       param.append($key, _params[$key]);
     }
     param.append("files", files);
   } else {
     for (var $key in _params) {
       param.append($key, _params[$key]);
     }
   }
   // 处理函数
   return new Promise((resolve, reject) => {
     let config = {
       headers: {
         'Content-Type': 'multipart/form-data',
         'access_token':localStorage.getItem('ACCESS-TOKEN')||'',
         'X-Requested-With': 'XMLHttpRequest',         
       },
       withCredentials: false
     }
     //进度回调
     if (_call) {
       config.onUploadProgress = progressEvent => { //原生获取上传进度的事件
         console.warn(progressEvent)
         if (progressEvent.lengthComputable) {
           //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
           //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
           _call(progressEvent);
           console.warn(progressEvent.total, progressEvent.loaded)
         }
       };
     }
     new axios.post(_url, param, config).then((res) => {
      if(res.data.code == 200 ){
        if(res.data.code == 200) {
          resolve(res.data)
        }else{
          resolve(res)
        }
      }else{
        Message({
          message: res.data.msg,
          type: "error"
        });
        reject(res.data)          
      }
     }).catch(reject);
   })
 }
 /*******************************************************************************************************************
  *************************************************API网络请求方法******************************************************
  *****************************API_FUNCTION是各种接口的实例，所有的接口都写入该方法********************************************
  *******************************************************************************************************************/
 export default {
   /**
    * 打开QQ聊天的窗口
    * @author 西门吹牛
    * @param {Object} e window.event
    * @param {Object} qq QQ号
    */
    openQQCaht(e, qq) {
     this.openNewWindow(e, `http:\/\/wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`);
     //		e = e || window.event;
     //		e.stopPropagation();
     //		var $a = document.createElement("a");
     //		$a.setAttribute("href",`http://wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`);
     //		$a.setAttribute("target",'_blank');
     //		$a.click();
    },
   /**
    * 打开旺旺聊天的窗口
    * @author 西门吹牛
    * @param {Object} e window.event
    * @param {Object} wangwang 旺旺昵称
    */
    openWangWangChat(e, wangwang) {
     this.openNewWindow(e,`http:\/\/www.taobao.com/webww/ww.php?ver=3&touid=${wangwang}&siteid=cntaobao&status=1&charset=utf-8`);
    },
   /**
    * 打开新的窗口
    * @author 西门吹牛
    * @param {Object} e window.event
    * @param {Object} ulr 打开地址
    * @param {Object} target 打开方式
    */
    openNewWindow(e, _ulr, _target = "_blank") {
     if(e) { e.stopPropagation(); }
     var $a = document.createElement("a");
     $a.setAttribute("href", _ulr);
     $a.setAttribute("target", _target);
     $a.click();
    },
    /*
    *  @description 获取token
    */    
    getUserToken(params) {
      return asyncRequestHandler(`${BASEURL}/buyer/login`, params, 'POST')
    },   
    buyerLogin(params) {
      return asyncRequestHandler(`${BASEURL}/buyer/login2/${params}`, '', 'get')
    }, 
    /** 
     * @description 后台登陆校验
     */
    buyerCheckLogin(params){
      return asyncRequestHandler(`${BASEURL}/buyer/check/log`, params, 'POST', 'Request Playload')
    },    
    /*
    *  @description 获取首页用户信息数据
    */
    getUserInfoDatas(params) {
      return asyncRequestHandler(`${BASEURL}/buyer/loginUser`, params, 'GET')
    },
    /*
    *  @description 获取首页用户信息数据
    */
    getBuyerInfo(params) {
      return asyncRequestHandler(`${BASEURL}/buyer/info`, params, 'GET')
    },
    /*
    *  @description 获取公告列表
    */
    getAnnouncement(params) {
      return asyncRequestHandler(`${BASEURL}/announcement/page`, params, 'GET')
    },    
    /*
    *  @description 查看添加阅读记录
    */
    viewAnnouncement(params) {
      return asyncRequestHandler(`${BASEURL}/announcement/view/${params}`,'', 'POST')
    },
    /*
    *  @description 查看添加阅读记录
    */
    getAnnouncementDetail(params) {
      return asyncRequestHandler(`${BASEURL}/announcement/get/${params}`,'', 'GET')
    },        
    /********************************* 短信条件控制 ***********************************/ 
    /*
    *  @description 淘宝短信签名查询
    */
    querySignName(params) {
      return asyncRequestHandler(`${BASEURL}/short-chain/sign/name/query`, params, 'GET')
    },  
    /*
    *  @description 淘宝短信签名创建接口
    */
    createSign(params) {
      return asyncRequestHandler(`${BASEURL}/short-chain/sign/name/create`, params, 'POST','Request Playload')
    },  
    /*
    *  @description 淘宝短信签名修改
    */
    applySign(params) {
      return asyncRequestHandler(`${BASEURL}/short-chain/sign/name/modify`, params, 'POST','Request Playload')
    },  
    /*
    *  @description 淘宝短信签名删除
    */
    deleteSign(params) {
      return asyncRequestHandler(`${BASEURL}/short-chain/sign/name/delete`, params, 'POST')
    },
    /*
    *  @description 生成短链
    */
    createShortUrl(params) {
      return asyncRequestHandler(`${BASEURL}/smsShortLink/generate`, params, 'GET')
    }, 
    /*
    *  @description 保存短链
    */
    addShortUrl(params) {
      return asyncRequestHandler(`${BASEURL}/smsShortLink/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description 删除短链
    */
    delShortUrl(params) {
      return asyncRequestHandler(`${BASEURL}/smsShortLink/remove/${params}`,'', 'POST')
    },
    /*
    *  @description 短链查询
    */
    queryShortUrl(params) {
      return asyncRequestHandler(`${BASEURL}/smsShortLink/page`, params, 'GET')
    },
    /*
    *  @description 短信测试
    */
    createTestSms(params) {
      return asyncRequestHandler(`${BASEURL}/smsTest/create`, params, 'POST','Request Playload')
    },
    /*
    *  @description 短信测试查询
    */
    pageTestSms(params) {
      return asyncRequestHandler(`${BASEURL}/smsTest/page`, params, 'POST','Request Playload')
    },
    
    // 短信模板 
    /*
    *  @description 短信模板查询
    */
    pageSmsTemplate(params) {
      return asyncRequestHandler(`${BASEURL}/smsTemplate/page`, params, 'GET')
    },
    /*
    *  @description 新建自定义短信模板
    */
    addTestSms(params) {
      return asyncRequestHandler(`${BASEURL}/smsTemplate/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description 删除自定义短信模板
    */
    removeSmsTemplate(params) {
      return asyncRequestHandler(`${BASEURL}/smsTemplate/remove/${params}`,'', 'POST')
    },
    /*
    *  @description 短信分类列表
    */
    categoriesSmsTemplate(params) {
      return asyncRequestHandler(`${BASEURL}/smsTemplate/categories/${params}`,'', 'GET')
    },                

    /********************************* 短信配置 ***********************************/ 
    /*
    *  @description crm短信任务添加
    */
    addNote(params) {
      return asyncRequestHandler(`${BASEURL}/note/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description crm短信任务删除
    */
    delteNote(params) {
      return asyncRequestHandler(`${BASEURL}/note/delte`, params, 'GET')
    },    
    /*
    *  @description crm短信任务查询
    */
    queryNoteList(params) {
      return asyncRequestHandler(`${BASEURL}/note/list`, params, 'POST','Request Playload')
    },

    // 指定号码发送
    /*
    *  @description 新建营销任务
    */
    createSpecifySms(params) {
      return asyncRequestHandler(`${BASEURL}/specify/sms/create`, params, 'POST','FormData')
    },
    /*
    *  @description 新建营销任务(导入模板)
    */
    createSpecifySmsFormData(params) {
      return asyncUploadHandler(`${BASEURL}/specify/sms/create`, params)
    },    
    /*
    *  @description 删除营销任务
    */
    removeSpecifySms(params) {
      return asyncRequestHandler(`${BASEURL}/specify/sms/remove/${params}`,'', 'POST')
    },
    /*
    *  @description 查询营销任务
    */
    querySpecifySms(params) {
      return asyncRequestHandler(`${BASEURL}/specify/sms/page`, params, 'GET')
    },        
    /*
    *  @description 下载模板
    */
    downloadTempSpecifySms(params) {
      return asyncRequestHandler(`${BASEURL}/specify/sms/downloadTemp`, params, 'POST', 'QueryString' , 'blob')
    },    
    
    // 短信黑名单
    /*
    *  @description 查询黑名单
    */
    queryBlackListSms(params) {
      return asyncRequestHandler(`${BASEURL}/blackListSms/page`, params, 'GET')
    },
    /*
    *  @description 删除黑名单
    */
    removeBlackListSms(params) {
      return asyncRequestHandler(`${BASEURL}/blackListSms/remove`, params, 'POST','Request Playload')
    },
    /*
    *  @description 全部删除
    */
    removeAllBlackListSms(params) {
      return asyncRequestHandler(`${BASEURL}/blackListSms/removeAll`, params, 'POST')
    },
    /*
    *  @description 导入黑名单
    */
    uploadBlackListSms(params) {
      return asyncUploadHandler(`${BASEURL}/blackListSms/upload`, params)
    },
    /*
    *  @description 添加黑名单
    */
    addBlackListSms(params) {
      return asyncRequestHandler(`${BASEURL}/blackListSms/add`, params, 'POST','Request Playload')
    },

    // 短信账单
    /*
    *  @description 日统计
    */
    dailySmsBillDaily(params) {
      return asyncRequestHandler(`${BASEURL}/smsBillDaily/daily`, params, 'GET')
    },
    /*
    *  @description 月统计
    */
    monthlySmsBillDaily(params) {
      return asyncRequestHandler(`${BASEURL}/smsBillDaily/monthly`, params, 'GET')
    },
    
    // 短信设置
    /*
    *  @description 查询短信设置
    */
    detailSmsSettings(params) {
      return asyncRequestHandler(`${BASEURL}/smsSettings/detail`, params, 'GET')
    },
    /*
    *  @description 保存短信设置
    */
    saveSmsSettings(params) {
      return asyncRequestHandler(`${BASEURL}/smsSettings/save`, params, 'POST','Request Playload')
    },
    /********************************* 人群标签控制 ***********************************/     
    /*
    *  @description 新增标签分组
    */
    addCrowdLabel(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/label/add`, params, 'POST')
    },
    /*
    *  @description 标签人群列表
    */
    queryCrowdLabelList(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/label/list`, params, 'POST','Request Playload')
    },  
    /*
    *  @description 编辑标签分组
    */
    updateCrowdLabel(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/label/update`, params, 'POST')
    },
    /*
    *  @description 删除标签分组
    */
    delCrowdLabel(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/label/del`, params, 'POST')
    },
    /*
    *  @description 新增商家人群
    */
    addCrowdGroup(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description 删除人群
    */
    delCrowdGroup(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/del`, params, 'POST')
    },
    /*
    *  @description 商家可用标签列表查询
    */
    queryCrowdTags(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/tags/query`, params, 'POST')
    },
    /*
    *  @description 根据tag标签信息获取该标签内置属性
    */
    getCrowdOpencrmTag(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/opencrm/tag/get`, params)
    },        

    /********************************* 图片素材控制 ***********************************/      
    /*
    *  @description 获取图片分类列表
    */
    queryCatePicList(params) {
      return asyncRequestHandler(`${BASEURL}/picture/category/list`, params, 'POST','Request Playload')
    }, 
    /*
    *  @description 获取当前会话用户出售中的商品列表
    */
    getOnSaleList(params) {
      return asyncRequestHandler(`${BASEURL}/item/onsale/get`, params, 'POST')
    },
    /*
    *  @description 获取当前会话用户仓库中的商品列表
    */
    getPutAwayList(params) {
      return asyncRequestHandler(`${BASEURL}/item/library/get`, params, 'POST')
    },
    /*
    *  @description 充值中心
    */
    rechargeHistory(params) {
      return asyncRequestHandler(`${BASEURL}/rechargeHistory/page`, params, 'GET')
    }, 
    /*
    *  @description 人群详情查询
    */
    getCrowdDetail(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/get/crowd`, params, 'GET')
    }, 
    /*
    *  @description 编辑人群
    */
    updateCrowd(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/update`, params, 'POST','Request Playload')
    },  
    /*
    *  @description 使用人群模式 发送短信
    */
    sendSmsCrowd(params) {
      return asyncRequestHandler(`${BASEURL}/smsCrowd/send`, params, 'POST','Request Playload')
    },   
    /*
    *  @description 统计人群买家覆盖信息
    */
    getCrowdNum(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/get/coverage/conunt`, params, 'GET')
    },  
    /*
    *  @description 统计标签组合覆盖买家信息
    */
    getCrowdTagNum(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/rules/crowd/conunt`, params, 'POST','Request Playload')
    }, 
    /*
    *  @description 人群短信发送记录
    */
    getSmsCrowdRecord(params) {
      return asyncRequestHandler(`${BASEURL}/smsCrowd/page`, params, 'GET')
    },  
    /*
    *  @description 操作日志
    */
    getOperaPage(params) {
      return asyncRequestHandler(`${BASEURL}/oper/page`, params, 'GET')
    }, 
    /*
    *  @description 获取订单交易列表
    */
    getOrderInfo(params) {
      return asyncRequestHandler(`${BASEURL}/orderInfo/get/info/list`, params, 'POST','Request Playload')
    },  
    /*
    *  @description 订单同步
    */
    sycOrder(params) {
      return asyncRequestHandler(`${BASEURL}/syc/order`, params, 'GET')
    },   
    /*
    *  @description 获取快捷标签列表
    */
    getFastTagList(params) {
      return asyncRequestHandler(`${BASEURL}/order-query/list`, params, 'GET')
    }, 
    /*
    *  @description 删除快捷标签
    */
    delFastTag(params) {
      return asyncRequestHandler(`${BASEURL}/order-query/del`, params, 'POST')
    },  
    /*
    *  @description 新增快捷标签
    */
    saveFastTag(params) {
      return asyncRequestHandler(`${BASEURL}/order-query/save`, params, 'POST','Request Playload')
    }, 
    /*
    *  @description 删除人群发送任务
    */
    delSmsCrowd(params) {
      return asyncRequestHandler(`${BASEURL}/smsCrowd/remove/${params}`,'', 'POST')
    }, 
    /*
    *  @description 新建订单发送短信任务
    */
    addOrderSms(params) {
      return asyncRequestHandler(`${BASEURL}/sms-order/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description 订单短信发送记录
    */
    getQueryOrderSms(params) {
      return asyncRequestHandler(`${BASEURL}/sms-order/page`, params, 'POST','Request Playload')
    },
    /*
    *  @description 删除订单发送任务
    */
    delSmsOrder(params) {
      return asyncRequestHandler(`${BASEURL}/sms-order/del`, params, 'POST')
    }, 
    /*
    *  @description 订单报表
    */
    getOrderReport(params) {
      return asyncRequestHandler(`${BASEURL}/orderInfo/report`, params, 'POST','Request Playload')
    },
    /*
    *  @description 查询充值模板
    */
    getRechargeTemplate(params) {
      return asyncRequestHandler(`${BASEURL}/rechargeTemplate/list`, params, 'GET')
    },
    /*
    *  @description 订单发送对象
    */
    getOrderObj(params) {
      return asyncRequestHandler(`${BASEURL}/sms-order/count`, params, 'POST','Request Playload')
    },
/*
    *  @description 查询对应人群的数量
    */
    queryOrderCrowd(params) {
      return asyncRequestHandler(`${BASEURL}/orderCrowd/query`, params, 'POST','Request Playload')
    },    
    /*
    *  @description 获取人群树形结构
    */
    getOrderCrowdTree(params) {
      return asyncRequestHandler(`${BASEURL}/orderCrowd/tree`, params, 'POST')
    },
    /*
    *  @description 添加人群分组
    */
    addOrderCrowdGroup(params) {
      return asyncRequestHandler(`${BASEURL}/orderCrowd/addGroup`, params, 'POST','Request Playload')
    },
    /*
    *  @description 修改人群分组
    */
    updateOrderCrowd(params) {
      return asyncRequestHandler(`${BASEURL}/orderCrowd/update`, params, 'POST','Request Playload')
    },
    /*
    *  @description 添加人群
    */
    addOrderCrowd(params) {
      return asyncRequestHandler(`${BASEURL}/orderCrowd/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description  删除人群分组
    */
    delOrderCrowd(params) {
      return asyncRequestHandler(`${BASEURL}/orderCrowd/delete/${params}`, '', 'POST')
    },
    /*
    *  @description 取分页关怀列表
    */
    getCareList(params) {
      return asyncRequestHandler(`${BASEURL}/order/care/setting/list`, params, 'GET')
    },
    /*
    *  @description 添加下单关怀设置
    */
    addCareSet(params) {
      return asyncRequestHandler(`${BASEURL}/order/care/setting/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description  删除下单关怀配置
    */
    delCareSet(params) {
      return asyncRequestHandler(`${BASEURL}/order/care/setting/del/${params}`, '', 'POST')
    },
    /*
    *  @description  根据id获取单个关怀任务
    */
    getOneCareSet(params) {
      return asyncRequestHandler(`${BASEURL}/order/care/setting/get/${params}`, '', 'GET')
    },
    /*
    *  @description 修改下单关怀配置
    */
    updateCareSet(params) {
      return asyncRequestHandler(`${BASEURL}/order/care/setting/update`, params, 'POST','Request Playload')
    },
    /*
    *  @description  获取配置项
    */
    getCareConfigList(params) {
      return asyncRequestHandler(`${BASEURL}/order/care/setting/configList`, params, 'GET')
    },
    /*
    *  @description 下单关怀发送记录
    */
    getCareLogList(params) {
      return asyncRequestHandler(`${BASEURL}/order/care/setting/logList`, params, 'POST','Request Playload')
    },
    /*
    *  @description 下单关怀效果统计
    */
    getCareEffectList(params) {
      return asyncRequestHandler(`${BASEURL}/order/care/setting/effectList`, params, 'POST','Request Playload')
    },
    /*
    *  @description 添加自动化营销设置
    */
    addAutoMarketSet(params) {
      return asyncRequestHandler(`${BASEURL}/birthdayInfo/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description  获取自动化营销配置列表
    */
    getAutoMarketList(params) {
      return asyncRequestHandler(`${BASEURL}/birthdayInfo/list`, params, 'GET')
    },  
    /*
    *  @description  根据id获取单个配置任务
    */
    getOneAutoMarketSet(params) {
      return asyncRequestHandler(`${BASEURL}/birthdayInfo/get/${params}`, '', 'GET')
    },  
    /*
    *  @description  删除自动化营销配置
    */
    delOneAutoMarketSet(params) {
      return asyncRequestHandler(`${BASEURL}/birthdayInfo/del/${params}`, '', 'POST')
    },   
    /*
    *  @description 修改自动化配置
    */
    editAutoMarketSet(params) {
      return asyncRequestHandler(`${BASEURL}/birthdayInfo/update`, params, 'POST','Request Playload')
    },  
    /*
    *  @description  单个标题检测
    */
    oneTitTest(params) {
      return asyncRequestHandler(`${BASEURL}/item/title/val`, params, 'GET')
    },  
    /*
    *  @description 获取违禁词列表
    */
    getBanInfo(params) {
      return asyncRequestHandler(`${BASEURL}/admin/banned-info/get/list`,params, 'GET')
    },
    /*
    *  @description 统计结果 
    */
    checkCount(params) {
      return asyncRequestHandler(`${BASEURL}/item/check/count`,params, 'GET')
    },
    /*
    *  @description 商品检测（可多个）
    */
    testPro(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/test`, params, 'POST','Request Playload')
    }, 
    testAllPro(params) {
      return asyncRequestHandler(`${BASEURL}/item/check`, params, 'GET')
    }, 
    /*
    *  @description 商品检测列表
    */
    checkLogList(params) {
      return asyncRequestHandler(`${BASEURL}/item/check/log/list`,params, 'GET')
    },
    /*
    *  @description 优惠券
    */
    getCouponList(params) {
      return asyncRequestHandler(`${BASEURL}/crowd/get/activity`, params, 'POST','Request Playload')
    },
    /*
    *  @description 获取退换货预警配置
    */
    getReturnInfo(params) {
      return asyncRequestHandler(`${BASEURL}/returnAlert/get`,params, 'GET')
    },
    /*
    *  @description 新增或修改预警
    */
    addReturnAlert(params) {
      return asyncRequestHandler(`${BASEURL}/returnAlert/add`, params, 'POST','Request Playload')
    },
    /*
    *  @description 预警发送记录
    */
    getReturnList(params) {
      return asyncRequestHandler(`${BASEURL}/returnAlert/page`, params, 'POST','Request Playload')
    },
    /*
    *  @description 退货分析
    */
    getReturnAlertAnalyseList(params) {
      return asyncRequestHandler(`${BASEURL}/returnAlert/analyse/list`, params, 'POST','Request Playload')
    },
    /*
    *  @description 退货订单列表
    */
    getReturnOrderList(params) {
      return asyncRequestHandler(`${BASEURL}/returnAlert/analyse/admin`, params, 'POST','Request Playload')
    },
    /*
    *  @description 客单价分析
    */
    getUnitPriceOrderInfo(params) {
      return asyncRequestHandler(`${BASEURL}/orderInfo/data/analysis`, params, 'POST','Request Playload')
    },
    /*
    *  @description 购买总额分析
    */
    getTotalSumOrderInfo(params) {
      return asyncRequestHandler(`${BASEURL}/orderInfo/order/analysis`, params, 'POST','Request Playload')
    },
    /*
    *  @description 购买频次分析
    */
    getFrequencyAnalysis(params) {
      return asyncRequestHandler(`${BASEURL}/orderInfo/frequency/analysis`, params, 'POST','Request Playload')
    },
    /*
    *  @description 获取RFM自定义参数
    */
    getRfmSet(params) {
      return asyncRequestHandler(`${BASEURL}/rfm/get`,params, 'GET')
    }, 
    /*
    *  @description 新增或修改RFM自定义参数
    */  
    saveOrUpdate(params) {
      return asyncRequestHandler(`${BASEURL}/rfm/saveOrUpdate`, params, 'POST','Request Playload')
    },
    /*
    *  @description rfm，首页跟r值分析
    */  
    getRFMAnalysis(params) {
      return asyncRequestHandler(`${BASEURL}/rfm/analysis`, params, 'POST','Request Playload')
    },
    /*
    *  @description 出售中的商品/地域列表
    */  
    getRFMPullDownList(params) {
      return asyncRequestHandler(`${BASEURL}/rfm/fromList`, params, 'POST','Request Playload')
    },
    /*
    *  @description RFM客户价值分析
    */  
    getRFMCustomerAnalysis(params) {
      return asyncRequestHandler(`${BASEURL}/rfm/customerAnalysis`, params, 'POST','Request Playload')
    },
    /*
    *  @description RFM客户特征模型
    */  
    getRFMCustomerModel(params) {
      return asyncRequestHandler(`${BASEURL}/rfm/customerModel`, params, 'POST','Request Playload')
    },
    /*
    *  @description rfm 短信发送
    */  
    getRFMSend(params) {
      return asyncRequestHandler(`${BASEURL}/rfm/send`, params, 'POST','Request Playload')
    },  
    /*
    *  @description 短信资质列表
    */
    queryQualificationSign(params) {
      return asyncRequestHandler(`${BASEURL}/qualification/from`, params, 'GET')
    }, 
    /*
    *  @description 短信签名资质报备提交接口
    */
    addQualificationSign(params) {
      return asyncRequestHandler(`${BASEURL}/qualification/add`, params, 'POST','Request Playload')
    }, 
    /*
    *  @description 上传图片
    */
    uploadImg(params) {
      return asyncUploadHandler(`${BASEURL}/picture/add`, params)
    }, 
  }
  



// WEBPACK FOOTER //
// ./src/api/api.js